import React from 'react';
import { Link } from 'react-router-dom';

// `onNavigate` lets the mobile menu close itself when the CTA is followed.
const AcceleratePromo = ({ onNavigate }) => (
  <div className='relative overflow-hidden rounded-2xl border border-[#E5E5E5] bg-white px-4 pt-6 pb-4 shadow-sm dark:border-white/10 dark:bg-[#23262E]'>
    {/* Blue glow bleeding in from the top right corner */}
    <div
      aria-hidden='true'
      className='pointer-events-none absolute -top-10 -right-8 h-28 w-28 rounded-full bg-mainblue opacity-25 blur-2xl dark:opacity-80'
    />
    <div className='relative'>
      <p className='text-[13px] font-bold text-mainblack dark:text-white'>
        Partners Accelerate
      </p>
      <p className='mt-3 text-[34px] font-light leading-none text-mainblack dark:text-white'>
        +2 tiers
      </p>
      <p className='mt-4 text-[13px] leading-snug text-gray-500 dark:text-gray-400'>
        Commit to a close date of 30 days or less when you register a new deal.
      </p>
      <Link
        to='/deal-registration'
        onClick={onNavigate}
        className='btn bg-yellow-gradient mt-4 flex items-center justify-between rounded-full px-4 py-2 text-sm font-medium text-mainblack'
      >
        <span>Register a deal</span>
        <span aria-hidden='true'>&rsaquo;</span>
      </Link>
    </div>
  </div>
);

export default AcceleratePromo;
